module.exports = __webpack_public_path__ + "static/yeenoghu-a9ebb20994e2c840ce7002b111a62c43.png";